import React from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Helmet } from "react-helmet";
import ComRuleEditor from './components/comRuleEditor';


const PageHome = () => {
	const [dotLottie, setDotLottie] = React.useState(null);
	const title = "Email Translation & Signature Tools | Sparkling Email";
	const description = "Sparkling Email, Enterprise Email Translation & Signature Platform. Server‑side email translation for bilingual Canadian & multilingual workplace. Seamless with Microsoft 365, Google Workspace & Zoho.";
	const h1Top = "Enterprise Email Tools";
	const featureTitle = "Key Features";
	const featureSubtitle = "Discover the advanced features of Sparkling Email";
	const features = [
		{
			"title": "Real-Time Translation",
			"description": "Translate emails instantly to support bilingual and multilingual business communication effortlessly."
		},
		{
			"title": "Server-Side Only",
			"description": "Fully server-side solution with no plugins or browser add-ons required for any users."
		},
		{
			"title": "Microsoft 365 Integration",
			"description": "Seamlessly integrates with Microsoft 365 Exchange Admin Center for centralized control and setup."
		},
		{
			"title": "Bilingual Canada Support",
			"description": "Designed specifically for English-French Canadian companies needing smooth bilingual communication."
		},
		{
			"title": "Enhanced Email Security",
			"description": "No third-party access or risky plugins—keeps your email environment secure and compliant."
		},
		{
			"title": "Smart Email Signatures",
			"description": "Create consistent, branded signatures with dynamic fields and automatic deployment."
		},
		{
			"title": "Boost Brand Consistency",
			"description": "Ensure brand-aligned emails with unified language, design, and signature policies."
		},
		{
			"title": "Compliance Ready Tools",
			"description": "Supports legal and corporate compliance with audit-friendly signature and translation features."
		},
		{
			"title": "Simplified IT Management",
			"description": "Streamline email tools administration with centralized, low-maintenance configuration options."
		}
	];
	const interactiveDemoTitle = "See Sparkling Email in Action";
	const interactiveDemoSubtitle = "Choose your settings and preview how emails are auto‑translated are applied in real time.";


	return <>
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
		</Helmet>
		<section className="container">
			<div id="about" className="row flex-grow-1 d-flex">
				<div className="col-12 col-xl-6 order-xl-1 order-2 text-center text-xl-start px-4">
					<h1 className="fw-bolder text-dark mt-5 ps-xl-5 fs-1 " style={{ lineHeight: '1.2' }}>{h1Top}</h1>
					<p className="fw-bold fs-6 text-muted ps-xl-5">for Microsoft 365, Google Workspace & Zoho Mail</p>
					<p className="fw-medium fs-7 text-secondary ps-xl-5">
						Server-side, real-time email translation<br />
						for bilingual Canadian (English-French) companies<br />
						and multilingual workplaces.
					</p>
					<a
						href="/app"
						className="btn btn-gold btn-lg px-4 ms-xl-5"
						target="_blank"
					>
						<span className="fw-bold">Try it for free</span>
					</a>
				</div >
				<div className="col-12 col-xl-6 order-xl-2 order-1">
					<DotLottieReact
						className='d-block mx-auto'
						src="/images/sparkling-email.lottie"
						loop
						autoplay
						onMouseEnter={() => dotLottie?.setSpeed(2)}
						onMouseLeave={() => dotLottie?.setSpeed(0.5)}
						dotLottieRefCallback={(ref) => setDotLottie(ref)}
					/>
				</div>
			</div>

			<div id="pricing" className="row justify-content-center text-center my-5">
				<div className="col-12">
					<h3 className="fw-bolder fs-2">{interactiveDemoTitle}</h3>
					<p className="fw-light mt-2 fs-5">{interactiveDemoSubtitle}</p>
				</div>
				<div className="col-12">
					<ComRuleEditor
						activeDomains={[
							"yourdomain.com",
						]}
						isDemo={true}
					/>
				</div>
			</div>

			<div id="features" className="row justify-content-center text-center my-5">
				<div className="col-12 mb-4">
					<h3 className="fw-bolder fs-2">{featureTitle}</h3>
					<p className="fw-light mt-2 fs-5">{featureSubtitle}</p>
				</div>
				<div className="d-flex flex-wrap justify-content-center gap-4 mb-5">
					{features.map((feature, index) => (
						<div
							key={index}
							className="col-5 col-xl-3 p-3 p-xl-4 text-center shadow-sm rounded-3 bg-light text-dark hover:bg-secondary hover:text-light"
							style={{ flex: '0 0 auto' }}

						>
							<h4 className="fw-medium mb-3">{feature.title}</h4>
							<p className="fw-light mt-2 fs-6">{feature.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	</>
}


export default PageHome